import React from "react";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { getLocalizedString } from "@icarius-localization/strings";
import { useAddRow } from "./useAddRow";

/**
 * Botón para agregar una fila a la grilla editable.
 * @param {object} props
 * @param {object} props.dataGridRef - Referencia al componente DataGrid
 */
const AddRowButton = ({ dataGridRef }) => {
  const addRow = useAddRow(dataGridRef);

  return (
    <CustomIconButton
      title={getLocalizedString("create")}
      onClick={addRow}
      type={"add"}
    />
  );
};

export default AddRowButton;
